import Vue from 'vue'
import Vuex from 'vuex'
import userAbroad from '../api/userAbroad'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
	state: {
		//存放的键值对就是所要管理的状态
		type: 0, //课程类型
		url:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/",
    name:'',//昵称
    avatar:'', //头像
    id:'', //用户id
    channel:'', //直播频道号
    live_id:'', //直播id
		courseDetails: [ //课程详情内容
			{
				name: "督学体验课",
				information: "购买即日起督学任务开始生效",
				time: "",
				price: "69.00",
				originalPrice: "825.00",
				contentImg: ['experience1.jpg', 'experience2.jpg', 'experience3.jpg', 'experience4.jpg', 'experience5.jpg',
					'experience6.jpg', 'experience7.jpg', 'experience8.jpg'
				],
				icon:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon1.png",
				color: "#F2B614",
				freeimg:"free1.png"
			},
			{
				name: "雅思1对1每日微课",
				information: "限时用劵立减，赠送雅思大礼包",
				time: "",
				price: "2200.00-9100.00",
				originalPrice: "3900.00-12800.00",
				contentImg: ['microlecture1.png', 'microlecture2.png', 'microlecture3.png', 'microlecture4.png',
					'microlecture5.png', 'microlecture6.png', 'microlecture7.png', 'microlecture8.png'
				],
					icon:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon2.png",
				color: "#A18CD1",
				freeimg:"free2.png"
			},
			{
				name: "雅思精品特训班",
				information: "限时用劵立减，赠送雅思大礼包",
				time: "",
				price: "8888.00",
				originalPrice: "12800.00",
				contentImg: ['class1.png', 'class2.png', 'class3.png', 'class4.png', 'class5.png', 'class6.png', 'class7.png',
					'class8.png'
				],
				icon:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon3.png",
				color: "#4AA297",
				freeimg:"free3.png",
			},
			{
				name: "雅思1对1提分宝",
				information: "限时用劵立减，赠送雅思大礼包",
				time: "",
				price: "19900.00",
				originalPrice: "28800.00",
				contentImg: ['onetoone1.png', 'onetoone2.png', 'onetoone3.png', 'onetoone4.png', 'onetoone5.png',
					'onetoone6.png', 'onetoone7.png', 'onetoone8.png', 'onetoone9.png', 'onetoone10.png'
				],
				icon:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon4.png",
				color: "#81C9FF",
				freeimg:"free4.png"
			},
			{
				name: "四级暑期特训营 - 备考12月",
				information: "考前抢分，灵活上课",
				time: "",
				price: "69.00",
				originalPrice: "199.00",
				contentImg: ['Level4-1.png', 'Level4-2.png', 'Level4-3.png', 'Level4-4.png', 'Level4-5.png',
					'Level4-6.png'],
				icon:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon4.png",
				color: "#4eac6c",
				freeimg:"free4.png"
			},
			{
				name: "六级暑期特训营 - 备考21年6月",
				information: "考前抢分，灵活上课",
				time: "",
				price: "69.00",
				originalPrice: "199.00",
				contentImg: ['Level6-1.png', 'Level6-2.png', 'Level6-3.png', 'Level6-4.png', 'Level6-5.png',
					'Level6-6.png'],
				icon:"https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/curriculum-icon4.png",
				color: "#2A70F4",
				freeimg:"free4.png"
			},
		]
	},

	mutations: {
    liveId(state,id){
      this.state.live_id =  id;
    },
		change(state,type) {
			this.state.type =  type;
		},
    name(state,name) {
    	this.state.name =  name;
    },
    avatar(state,avatar){
      	this.state.avatar = avatar;
    },
    ids(state,id){
      	this.state.id = id;
    },
    getChannel(state,channel){
      this.state.channel= channel;
    }

	},

  modules: {
    userAbroad
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js